import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { User } from '../user/user';

@Injectable()
export class Notes {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/marketing/notes', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/marketing/notes/delnotes', params);
  }


  post(params?: any) {
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/marketing/notes', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/marketing/notes/notes.ts